(function () {
  'use strict';

  function updateLowStockNotice(container, variant) {
    var notice = container.querySelector(
      '[data-low-stock-notice][data-low-stock-context="pdp"]'
    );

    if (!notice || !variant) return;

    var threshold = Number(notice.getAttribute('data-low-stock-threshold'));
    var quantity = Number(variant.inventory_quantity);
    var shouldShow =
      threshold > 0 &&
      variant.inventory_management === 'shopify' &&
      quantity > 0 &&
      quantity <= threshold;

    notice.hidden = !shouldShow;

    if (shouldShow) {
      var message = notice.getAttribute('data-low-stock-message') || '';
      notice.textContent = message.replace(/\[quantity\]/g, quantity);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery) return;

    window.jQuery(document).on(
      'variantChange',
      '[data-product-detail-form]',
      function (event) {
        updateLowStockNotice(this, event.variant);
      }
    );
  });
})();
